<template>
  <nav class="glass-nav" :style="{ marginLeft: 'var(--sidebar-width, 220px)', transition: 'margin-left 0.25s ease' }">
    <button class="mobile-menu-btn" @click="toggleMobileMenu">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </button>

    <div class="nav-links" :class="{ 'mobile-open': isMobileMenuOpen }" style="margin-left: auto;">
      <a href="#" class="nav-item">Home</a>
      <a href="#" class="nav-item">About</a>
      <a href="#" class="nav-item">Contact</a>

      <!-- User Pill with Dropdown -->
      <div class="user-pill-container">
        <div class="user-pill" @click="toggleDropdown">
          <div class="user-avatar">{{ userInitials }}</div>
          <span>{{ userName || 'Admin User' }}</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            style="margin-left: 4px; opacity: 0.7;">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>

        <!-- Dropdown Menu -->
        <div v-if="showDropdown" class="user-dropdown">
          <router-link to="/profile" class="dropdown-item" @click="showDropdown = false">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            <span>Profile Settings</span>
          </router-link>
          <a href="#" class="dropdown-item logout" @click.prevent="handleLogout">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>Logout</span>
          </a>
        </div>
      </div>
    </div>
  </nav>

  <!-- Page-specific action bar — pages Teleport their title+buttons here -->
  <div id="page-action-bar" :style="{ marginLeft: 'var(--sidebar-width, 220px)', transition: 'margin-left 0.25s ease' }"></div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SuperAdminHeader',
  data() {
    return {
      isMobileMenuOpen: false,
      showDropdown: false,
      userName: ''
    }
  },
  async mounted() {
    await this.fetchProfile();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    userInitials() {
      const name = this.userName || 'A';
      return name
        .split(' ')
        .map(w => w[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }
  },
  methods: {
    async fetchProfile() {
      try {
        const response = await axios.get(`${this.$API_URL}/super_admin/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('super_admin_token')}` }
        });
        this.userName = response.data.name;
      } catch (err) { console.error(err); }
    },
    toggleMobileMenu(event) {
      event.stopPropagation();
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    toggleDropdown(event) {
      event.stopPropagation();
      this.showDropdown = !this.showDropdown;
    },
    handleClickOutside(event) {
      const container = document.querySelector('.user-pill-container');
      if (container && !container.contains(event.target)) {
        this.showDropdown = false;
      }
    },
    handleLogout() {
      this.showDropdown = false;
      localStorage.removeItem('super_admin_token');
      window.location.href = '/';
    }
  }
}
</script>

<style scoped>
/* Page action bar — teleport target for page-specific title + buttons */
#page-action-bar:not(:empty) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  height: 48px;
  background: rgba(245, 248, 252, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(15, 36, 64, 0.08);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  position: sticky;
  top: 64px;
  z-index: 998;
  gap: 1rem;
}

#page-action-bar:empty {
  display: none;
}

.user-pill-container {
  position: relative;
}

.user-pill {
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #001F3F;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.05em;
}

.user-pill:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.user-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  padding: 8px;
  z-index: 1000;
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: #2c3e50;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 0.95rem;
  font-weight: 500;
}

.dropdown-item:hover {
  background: rgba(0, 113, 197, 0.1);
  color: #0071C5;
}

.dropdown-item.logout:hover {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}

.dropdown-item svg {
  flex-shrink: 0;
}
</style>
